// extracted by mini-css-extract-plugin
export default {"mainWrapper":"NotFound_mainWrapper__Pa8Aa","oops":"NotFound_oops__0azi4","rest":"NotFound_rest__vnr7C"};